const deploy = require("./lib/deployer/deploy");
const deployMany = require("./lib/deployer/deploymany");

module.exports = {
  deploy,
  deployMany
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-legacy-system/index.js
// module id = 2774
// module chunks = 0 1